import React, { useState, useEffect, useRef } from 'react';
import { Icon, IconClose } from '../../../base/icons';

import { sendData } from '../../../webjam/websocket';

// css box-metronome
import './box-metronome.css';

import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import { FEATURE_CUSTOM_REDUX } from '../../constant';
import { SaveLog } from '../../Utils';
import { socketEmit, socketOn } from '../../../../../socket';
import { ct } from '../../constant-Utils';
import { CURRENT_ROOM_LOCATION } from '../../../webjam/constant';

var timeoutId = 0;
let fiveSec = 5000;
var turnedOn = false;
let beatCount = 6;
let timeoutLoader;

const BoxMetronome = (props) => {
	const { Sessions, closeTool, usersData, roomorIpAddress, metronomeStatus, toolOpenLocal } = props;
	//const beepElement = useRef(1);
	const { openByUser, SessionId } = Sessions;

	// setting default beat
	const [defaultBeat, setBeat] = useState({
		bpm: usersData?.bpm ? usersData?.bpm : 100,
		bpb: usersData?.ticks ? usersData?.ticks : 4,
		timer: false,
	});

	const [value, setValue] = useState(0.8);
	const [isLocalUser, setIsLocalUser] = useState(false);


	const handleVolume = (val, newVal) => {
		val = parseFloat(val).toFixed(1);
		setValue(val);

		const message = {
			action: {
				uniqueID: usersData?.uniqueId,
				ipAddress: roomorIpAddress,
				volume: val
			},
			content: 'set-volume',
			isBroadcast: true,
			sender: 'mobile'
		};

		if (timeoutLoader) {
			clearTimeout(timeoutLoader);
		}
		timeoutLoader = setTimeout(function () {

			//-------------Prepare logger data -------------
			var log_data = {
				functionName: '',
				triggeredBy: 'system',
				event: message.content,
				requestData: message,
				responseData: '',
				userId: '',
				boxId: message.action.uniqueID,
				message: 'Emit to server'
			}
			SaveLog(log_data);
			//-------------------------------------------

			sendData(message);
		}, 1000);
		//}

	};

	// hide buttons and cross buttons
	const [isDisable, setIsDisable] = useState(false);

	// setting the audio stream
	useEffect(() => {
		if (SessionId !== openByUser) {
			setIsDisable(true);
		} else {
			setIsDisable(false);
			turnedOn = false;
			if (document.getElementById("bpmPlus")) {
				document.getElementById("bpmPlus")?.removeAttribute("disabled");
				document.getElementById("bpmMinus")?.removeAttribute("disabled");
				document.getElementById("bpm")?.removeAttribute("disabled");
				document.getElementById("bpbPlus")?.removeAttribute("disabled");
				document.getElementById("bpbMinus")?.removeAttribute("disabled");
				document.getElementById("bpb")?.removeAttribute("disabled");
				document.getElementById("start")?.removeAttribute("disabled");
				document.getElementById("stop")?.setAttribute("disabled", "disabled");
			}
			//close();
		}

		return function cleanup() {
			clearTimeout(timeoutId);
		};
	}, [openByUser]);

	// changes in beat
	const beatChange = (e) => {
		const { name, value } = e.target;
		if (isDisable) {
			return;
		}

		// setting metnome
		setBeat({
			...defaultBeat,
			[name]: value
		});
	}

	// Action buttons
	const beatAction = (field, actionType) => {
		const currentValue = parseFloat(defaultBeat[field]);

		if (actionType === 'minus') {
			// minus button
			setBeat({
				...defaultBeat,
				[field]: currentValue - 1
			});
		} else {
			setBeat({
				...defaultBeat,
				[field]: currentValue + 1
			});
		}
	}

	// start
	const start = () => {
		if (turnedOn) {
			return false;
		}

		beatCount = 6;
		setBeat({
			...defaultBeat,
			timer: true
		});

		const { bpm, bpb } = defaultBeat;
		const message = {
			action: {
				uniqueID: usersData?.uniqueId,
				ipAddress: roomorIpAddress,
				bpm: parseInt(bpm),
				ticks: parseInt(bpb)
			},
			content: 'start-metronome',
			isBroadcast: true,
			sender: 'mobile'
		};

		//-------------Prepare logger data -------------
		var log_data = {
			functionName: '',
			triggeredBy: 'system',
			event: message.content,
			requestData: message,
			responseData: '',
			userId: '',
			boxId: message.action.uniqueID,
			message: 'Emit to server'
		}
		SaveLog(log_data);
		//-------------------------------------------

		sendData(message);

		beat();
		turnedOn = true;
		document.getElementById("start")?.setAttribute("disabled", "disabled");
		document.getElementById("bpmPlus")?.setAttribute("disabled", "disabled");
		document.getElementById("bpmMinus")?.setAttribute("disabled", "disabled");
		document.getElementById("bpm")?.setAttribute("disabled", "disabled");
		document.getElementById("bpbPlus")?.setAttribute("disabled", "disabled");
		document.getElementById("bpbMinus")?.setAttribute("disabled", "disabled");
		document.getElementById("bpb")?.setAttribute("disabled", "disabled");
		document.getElementById("stop")?.removeAttribute("disabled");
	};

	const stop = () => {
		clearTimeout(timeoutId);
		turnedOn = false;

		const message = {
			action: {
				uniqueID: usersData?.uniqueId,
				ipAddress: roomorIpAddress
			},
			content: 'stop-metronome',
			isBroadcast: true,
			sender: 'mobile'
		};

		// if (SessionId !== openByUser) {
		// 	message.content = 'stop-my-metronome';
		// }

		if (!toolOpenLocal) {
			message.content = 'stop-my-metronome';
		}


		//-------------Prepare logger data -------------
		var log_data = {
			functionName: '',
			triggeredBy: 'system',
			event: message.content,
			requestData: message,
			responseData: '',
			userId: '',
			boxId: message.action.uniqueID,
			message: 'Emit to server'
		}
		SaveLog(log_data);
		//-------------------------------------------

		sendData(message);

		if (document.getElementById("bpmPlus")) {
			document.getElementById("bpmPlus").removeAttribute("disabled");
			document.getElementById("bpmMinus").removeAttribute("disabled");
			document.getElementById("bpm").removeAttribute("disabled");
			document.getElementById("bpbPlus").removeAttribute("disabled");
			document.getElementById("bpbMinus").removeAttribute("disabled");
			document.getElementById("bpb").removeAttribute("disabled");
			document.getElementById("start").removeAttribute("disabled");
			document.getElementById("stop").setAttribute("disabled", "disabled");
		}
	};

	function beat() {
		const { bpm, bpb, timer } = defaultBeat;

		beatCount--;
		timeoutId = setTimeout(beat, (fiveSec / 5));
		if (document.getElementById("beatIndicator") != null) {
			document.getElementById("beatIndicator").innerHTML = beatCount;
		}

		if (beatCount < 1) {
			setBeat({
				...defaultBeat,
				timer: false
			});
			clearTimeout(timeoutId);
			turnedOn = false;
			//clearTimeout(timeoutLoader);
		}
	};


	useEffect(() => {
		if (toolOpenLocal) {
			setIsLocalUser(true)
		}

		socketOn("closetool_return", data => {

			if (data.location == CURRENT_ROOM_LOCATION) {
				if (toolOpenLocal == false && data.toolName == "box-metronome") {
					props.openToolStatus({
						isMain: false
					}, "box-metronome");
				}
			}
		})

		return () => {
			stop();
		}
	}, [])

	const handleClose = () => {
		if (toolOpenLocal) {
			props.openToolStatus({
				isMain: true
			}, "box-metronome");

			socketEmit("closetool", {
				location: CURRENT_ROOM_LOCATION,
				toolName: "box-metronome",
				isMain: true
			})
		} else {
			props.openToolStatus({
				isMain: false
			}, "box-metronome");
		}
	}


	return (
		<div className="metrono-outer">
			<div className="low-metro" id="metronome">

				<div
					className='close-side-bar'
					//onClick={closeTool}
					onClick={handleClose}
				>
					<Icon src={IconClose} />
				</div>

				<div id="metronomeBg">
					<div className="beatwrapper">
						<div id="beatBarContainer">
							<div id="beatBar">&nbsp;</div>
						</div>
						<div id="beatIndicatorContainer">
							{defaultBeat?.timer &&
								<div id="beatIndicator" className="beep">{beatCount}</div>
							}
						</div>
						<div id="settingsContainer" >
							<div id="settings" className="row setting">
								<div className="col-sm-6 start">
									<label>{ct("rta-trmc.tools.beatsPerMinute")}:</label>
									<input type="text" name="bpm" id="bpm" onChange={beatChange} value={defaultBeat?.bpm} style={{ width: "60px", paddingLeft: "11px" }} autoComplete='off' />
									{(!isDisable || toolOpenLocal) &&
										<input type="button" onClick={() => beatAction('bpm', 'plus')} name="bpmPlus" id="bpmPlus" className="plusMinus" value="+" />
									}
									{(!isDisable || toolOpenLocal) &&
										<input type="button" onClick={() => beatAction('bpm', 'minus')} name="bpmMinus" id="bpmMinus" className="plusMinus" value="-" />
									}
									{isLocalUser && <input type="button" onClick={start} name="start" id="start" value={ct("rta-trmc.tools.startBtn")} />}
								</div>
								<div className="col-sm-6 stop">
									<label>{ct("rta-trmc.tools.beatsPerBar")}:</label>
									<input type="text" name="bpb" onChange={beatChange} id="bpb" value={defaultBeat?.bpb} style={{ width: "60px", paddingLeft: "11px" }} autoComplete='off' />
									{(!isDisable || toolOpenLocal) &&
										<input type="button" onClick={() => beatAction('bpb', 'plus')} name="bpbPlus" id="bpbPlus" className="plusMinus" value="+" />
									}
									{(!isDisable || toolOpenLocal) &&
										<input type="button" onClick={() => beatAction('bpb', 'minus')} name="bpbMinus" id="bpbMinus" className="plusMinus" value="-" />
									}
									{/* { !isDisable && */}
									<input type="button" onClick={stop} name="stop" id="stop" value={ct("rta-trmc.tools.stopBtn")} />
									{/* } */}
								</div>

								<div className="col-sm-6 stop">
									<label>{ct("rta-trmc.tools.volume")}:</label>
									<Slider className="mxxx-slider"
										min={0}
										max={0.8}
										step={0.1}
										name='volumeLevel'
										orientation='horizontal'
										value={value}
										defaultValue={value}
										onChange={handleVolume}
									/>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
			<div id="audioHide">
				<audio id="beepOne" src="sounds/beep-7.wav" preload="auto" controls="controls">{ct("rta-trmc.tools.standardsBrowers")}</audio>
				<audio id="beepTwo" src="sounds/beep-8.wav" preload="auto" controls="controls">{ct("rta-trmc.tools.standardsBrowers")}</audio>
			</div>
		</div>
	);
}

export default BoxMetronome;
